import { ParsedUrlQuery } from 'node:querystring';

import { ApiSubDomainLookup } from 'constants/api.constants';
import { AppSyncGraphQLError } from 'queries/types';

export const getGraphqlEndpointByService = (
  service: keyof typeof ApiSubDomainLookup,
) => {
  const subDomain = ApiSubDomainLookup[service];

  const url = process.env.NEXT_PUBLIC_API_URL!.replace(
    /https:\/\/([\w\.]+)/,
    `https://${subDomain}.$1/graphql`,
  );
  return url;
};

const errorIntlIdLookup = {
  AccountExists: 'api.error.account.exists',
  SaudiRewardsRequestError: 'api.error.saudi.rewards',
};

export const getIntlIdFromGraphqlError = (error: AppSyncGraphQLError) => {
  const errorType = error.response.errors[0].errorType;
  const intlId = errorIntlIdLookup[errorType as keyof typeof errorIntlIdLookup];

  if (!!intlId) return intlId;
};

export const queryParam = (
  query: ParsedUrlQuery,
  key: string,
  fallback: string | undefined = '',
): string => (typeof query[key] === 'string' ? query[key] : fallback);
